import { MessageTypeEnum, PriorityEnum, UserRolesEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, ManyToOne, JoinColumn, OneToMany, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';


@Entity('user')
export class User {

    @PrimaryGeneratedColumn('increment', {
        name: 'user_id'
    })
    id: number;

    @Column('int', {
        nullable: false,
        name: 'company_id'
    })
    companyId: number;

    @Column('varchar', {
        nullable: false,
        name: 'role',
        length: 30,
    })
    role: UserRolesEnum;

    @Column('varchar', {
        nullable: false,
        name: 'username',
        length: 40
    })
    username: string;

    @Column("varchar", {
        nullable: false,
        name: "password",
        length: 40
    })
    password: string;

    @Column("int", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}

